import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './Router/routeList/routes';

function App() {

  const isLoggedIn = () => {
    let token = localStorage.getItem("access_token");
    return token ? true : false;
  };

  return (
    <>
      <BrowserRouter basename="">
        <Router isLoggedIn={isLoggedIn} />
      </BrowserRouter>
    </>
  );
}

export default App;
